<div class="attachments-container">
    <div
        class="attachment-content"
        [ngClass]="{ 'new-attachments dx-theme-accent-as-border-color': isNewAttachmentExists }"
    >
        <dx-button type="default" stylingMode="text" template="buttonTemplate" (onClick)="onViewAttachmentClick()">
            <div *dxTemplate="let content of 'buttonTemplate'">
                <div class="item-container">
                    <div class="item-image">
                        <i class="fa-lg" [ngClass]="attachmentIcon"></i>
                    </div>
                    <div *ngIf="attachmentCount > 0" class="badge-container">({{ attachmentCount }})</div>
                </div>
            </div>
        </dx-button>
        <dx-menu
            *ngIf="!viewOnly"
            displayExpr="text"
            cssClass="menu-items"
            orientation="vertical"
            [hideSubmenuOnMouseLeave]="true"
            [showFirstSubmenuMode]="{ name: 'onHover', delay: { show: 0, hide: 300 } }"
            [items]="attachmentOptions"
            (onItemClick)="onAttachmentClick($event)"
        ></dx-menu>
    </div>
    <div class="attach-file">
        <dx-file-uploader
            #fileUploader
            labelText="Drop file here"
            uploadMode="useButtons"
            [multiple]="true"
            [showFileList]="false"
            [maxFileSize]="4000000"
            [visible]="false"
            (onValueChanged)="onAttachmentsSelect($event)"
        ></dx-file-uploader>
    </div>
</div>

<app-property-community-documents
    #propertyCommunityDocuments
    (onAttach)="onAttachDocuments($event)"
></app-property-community-documents>

<app-attachment-selector
    *ngIf="showAttachments"
    [visible]="showAttachments"
    [communityId]="communityId"
    [customerId]="customerId"
    [viewOnly]="viewOnly"
    [isDeleteEnabled]="isDeleteEnabled"
    [allowBulkSave]="allowBulkSave"
    [selectedAttachments]="selectedAttachments"
    (onAttachmentUpdate)="onAttachDocuments($event)"
    (onClose)="onViewerClose()"
    (onSave)="onSaveClick()"
></app-attachment-selector>

<cc-message-box #messageBox></cc-message-box>
